module.exports = __webpack_public_path__ + "img/banner_ongoing_EN.fe78e402.png";